import { render } from "./DtmfKeyboard.vue?vue&type=template&id=62ce1621&scoped=true&ts=true&lang=pug"
import script from "./DtmfKeyboard.vue?vue&type=script&lang=ts"
export * from "./DtmfKeyboard.vue?vue&type=script&lang=ts"

import "./DtmfKeyboard.vue?vue&type=style&index=0&id=62ce1621&scoped=true&lang=css"

import exportComponent from "E:\\UiDesk\\laragon-5.0.0\\www\\click-to-call\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ce1621"]])

export default __exports__